module.exports = __webpack_public_path__ + "img/picture_viptk06.14eb5a1f.png";